// Polyfill sessionStorage for non-browser environments (e.g., Node.js/Jest)
if (typeof sessionStorage === 'undefined') {
  global.sessionStorage = {
    _data: {},
    getItem(key) { return this._data[key] || null; },
    setItem(key, value) { this._data[key] = value.toString(); },
    removeItem(key) { delete this._data[key]; },
    clear() { this._data = {}; }
  };
}

// export const rnduts =
//   "rWt9nnVmfkjHW4eZsZmC2Yufspi2qHqNqs2W6rN5paiYnrSXwa2dqt1grI+Kn5zql3Whh5p5o6aJrKqn";

// export const encstr =
//   "ZJ14fYu2mrCIkYdtin+abJxpjnq7nItnfHvFtKh9g6GopmfHZbiWm93YlaZzba+fpm5mk5xlZ2ycbm1pkXCosQ==";

export const X_Auth_Token = (() => {
  const token = sessionStorage.getItem("accessToken");
  try {
    return token ? JSON.parse(token).accessToken : "";
  } catch (error) {
    console.error("Invalid accessToken in sessionStorage", error);
    return "";
  }
})();

export const sessionId = "_ss_1662121702937id7044310be80b";

export const header_without_xauth = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  sessionId: sessionId,
  // rnduts: rnduts,
  // encstr: encstr,
};

export const header_with_xauth = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  sessionId: sessionId,
  // rnduts: rnduts,
  // encstr: encstr,
  "X-Auth-Token": X_Auth_Token,
};

export const get_header_with_xauth = () => {
  let accessToken = "";
  const accessTokenStr = sessionStorage.getItem("accessToken");
  if (accessTokenStr) {
    try {
      accessToken = JSON.parse(accessTokenStr).accessToken;
    } catch (e) {
      console.error("Invalid accessToken in sessionStorage", e);
      accessToken = "";
    }
  }
  const isExternalUser = sessionStorage.getItem("isExternalUser") === "true";
  return {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    sessionId: sessionStorage.getItem("_ss_i") || "",
    // rnduts: sessionStorage.getItem("_rr_n_dts") || "",
    // encstr: sessionStorage.getItem("_en_cs") || "",
    "X-Auth-Token": accessToken,
  };
};

export const header_without_sessionId = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  // rnduts: rnduts,
  // encstr: encstr,
};
